import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

//Compoments
import DashboardMenu from '../../components/dashboard/DashboardMenu';
import Header from '../../components/layouts/header';
import FormPerguntasValidacao from '../../components/forms/FormPerguntasValidacao';
import Body from '../../components/layouts/body';


class ConfValidacaoFormPerguntas extends React.Component {
        
    render() {
        return (
            <>            
            <DashboardMenu />
            <Header titulo="Validação de Perguntas" subtitulo="Cadastro" descricao="" />
            <Body>                
                <FormPerguntasValidacao  />
            </Body>
            </>
        )
    }
}

export default connect()(withRouter(ConfValidacaoFormPerguntas));